import React from "react";

// ===============================
// CONSTANTS
// ===============================
const STATUS_STYLES = {
  Completed: "bg-green-100 text-green-800",
  "In Progress": "bg-blue-100 text-blue-800",
  "On Hold": "bg-yellow-100 text-yellow-800",
  Cancelled: "bg-red-100 text-red-800",
  default: "bg-gray-100 text-gray-800",
};

// ===============================
// COMPONENT
// ===============================
const StatusBadge = ({ status }) => {
  const statusClass = STATUS_STYLES[status] || STATUS_STYLES.default;

  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap flex-shrink-0 ${statusClass}`}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
